// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  It applies to page with side bar.
  Example: systemParams -> systemParams.component.scss
*/
/*
  It applies to the title (header) of page content body.
*/
/*
  It describes common behavior on mouse hover.
*/
/*
  It describes light shadow for any page block.
*/
/*
  It applies to entity block like project, facility which has own title, edit button and body.
*/
/*
  It applies together with entity-card mixin, which has been described above
*/
/*
  It applies together with 'entity-card' mixin, which has been described above.
*/
/*
  It applies together with 'entity-card' mixin, which has been described above.
*/
.ic-question-option__option {
  position: relative;
  padding-left: 26px;
  /* Base for label styling */
  /* radio circle */
  /* disabled radio */
  /* disabled radio label */
  display: inline-block;
  margin-bottom: 8px;
}
.ic-question-option__option [type=radio]:not(:checked),
.ic-question-option__option [type=radio]:checked {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  color: #212121;
}
.ic-question-option__option [type=radio]:not(:checked) + span:before,
.ic-question-option__option [type=radio]:checked + span:before {
  content: "";
  position: absolute;
  top: 2px;
  left: 0;
  width: 18px;
  height: 18px;
  cursor: pointer;
  border: 1px solid #009dd9;
  border-radius: 18px;
}
.ic-question-option__option [type=radio] + span {
  cursor: pointer;
}
.ic-question-option__option [type=radio] + span:before {
  background-size: cover;
}
.ic-question-option__option [type=radio]:checked + span:after {
  content: "";
  position: absolute;
  top: 6px;
  left: 4px;
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: #009dd9;
  border: 1px solid #009dd9;
}
.ic-question-option__option [type=radio]:disabled:not(:checked) + span:before,
.ic-question-option__option [type=radio]:disabled:checked + span:before {
  cursor: default;
  pointer-events: none;
}
.ic-question-option__option [type=radio]:disabled:not(:checked) + span:after {
  opacity: 0;
}
.ic-question-option__option [type=radio]:disabled:checked + span:after {
  opacity: 0.5;
}
.ic-question-option__option [type=radio]:disabled + span {
  color: #c8c8c8;
  cursor: default;
  pointer-events: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
